// ********* GET COMPANY DEATILS **************************
export const GET_COMPANY_DETAILS_INITIATED = "GET_COMPANY_DETAILS_INITIATED";
export const GET_COMPANY_DETAILS_SUCCESS = "GET_COMPANY_DETAILS_SUCCESS";
export const GET_COMPANY_DETAILS_FAILED = "GET_COMPANY_DETAILS_FAILED";

// ********* UPDATE COMPANY DEATILS ************************
export const UPDATE_COMPANY_DETAILS_INITIATED = "UPDATE_COMPANY_DETAILS_INITIATED";
export const UPDATE_COMPANY_DETAILS_SUCCESS = "UPDATE_COMPANY_DETAILS_SUCCESS";
export const UPDATE_COMPANY_DETAILS_FAILED = "UPDATE_COMPANY_DETAILS_FAILED";
